import { render, staticRenderFns } from "./ListGoldOrder.vue?vue&type=template&id=f3a16658"
import script from "./ListGoldOrder.vue?vue&type=script&lang=js"
export * from "./ListGoldOrder.vue?vue&type=script&lang=js"
import style0 from "./ListGoldOrder.vue?vue&type=style&index=0&id=f3a16658&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports